import { Takeover } from '@/components/ui/Takeover';
import { TaskListDetail } from '@/pages/TaskListDetail';

/**
 * Full-screen takeover for a task list's detail view. Overlays the current page
 * instead of navigating to the /tasks/:listId route, so the user keeps their
 * place on the task landing.
 */
export function TaskListTakeover({
  listId,
  projectId,
  initialFilterAssignee,
  onClose,
}: {
  listId: string;
  projectId: string;
  /** Pre-applies an assignee filter, carried over from the landing page. */
  initialFilterAssignee?: string | null;
  onClose: () => void;
}) {
  return (
    <Takeover onClose={onClose}>
      <TaskListDetail
        listId={listId}
        projectId={projectId}
        initialFilterAssignee={initialFilterAssignee}
        onClose={onClose}
      />
    </Takeover>
  );
}
